import { type DashRouteType, URL_RETAILER_SCOPED } from 'utils/routing/routes'

const URL_INSIGHTS_PORTAL = `${URL_RETAILER_SCOPED}/insights-portal`
const URL_INSIGHTS_PORTAL_CUSTOM_REPORT = `${URL_INSIGHTS_PORTAL}/custom-report`
const URL_INSIGHTS_PORTAL_REDIRECT_PAGE = `${URL_INSIGHTS_PORTAL}/redirect-page`
const URL_INSIGHTS_PORTAL_PERFORMANCE_DASHBOARD = `${URL_INSIGHTS_PORTAL}/performance-dashboard`
const URL_INSIGHTS_PORTAL_OUT_OF_STOCK_DASHBOARD = `${URL_INSIGHTS_PORTAL}/out-of-stock-dashboard`
const URL_INSIGHTS_PORTAL_BASKET_DASHBOARD = `${URL_INSIGHTS_PORTAL}/basket-dashboard`
const URL_INSIGHTS_PORTAL_SEARCH_DASHBOARD = `${URL_INSIGHTS_PORTAL}/search-dashboard`
const URL_INSIGHTS_PORTAL_ADS_DASHBOARD = `${URL_INSIGHTS_PORTAL}/ads-dashboard`
const URL_INSIGHTS_PORTAL_SUMMARY_REPORT = `${URL_INSIGHTS_PORTAL}/summary-report`
const URL_INSIGHTS_PORTAL_SUMMARY_REPORT_PDF = `${URL_INSIGHTS_PORTAL}/summary-report-pdf`
const URL_INSIGHTS_PORTAL_DATA_EXPLORER = `${URL_INSIGHTS_PORTAL_CUSTOM_REPORT}/new`
const URL_INSIGHTS_PORTAL_REPORT_PREVIEW_NEW = `${URL_INSIGHTS_PORTAL_CUSTOM_REPORT}/preview/`
const URL_INSIGHTS_PORTAL_REPORT_PREVIEW_EXISTING = `${URL_INSIGHTS_PORTAL_CUSTOM_REPORT}/preview/:reportId`
const URL_INSIGHTS_PORTAL_CUSTOM_REPORT_LIST = `${URL_INSIGHTS_PORTAL_CUSTOM_REPORT}/list`
const URL_INSIGHTS_PORTAL_PERFORMANCE = `${URL_INSIGHTS_PORTAL}/performance`
const URL_INSIGHTS_PORTAL_PERFORMANCE_OVERVIEW = `${URL_INSIGHTS_PORTAL}/performance/overview`
const URL_INSIGHTS_PORTAL_PERFORMANCE_BASKET = `${URL_INSIGHTS_PORTAL}/performance/basket`
const URL_INSIGHTS_PORTAL_PERFORMANCE_OUT_OF_STOCK = `${URL_INSIGHTS_PORTAL}/performance/out-of-stock`
const URL_INSIGHTS_PORTAL_PERFORMANCE_SEARCH = `${URL_INSIGHTS_PORTAL}/performance/search`
const URL_INSIGHTS_PORTAL_EXECUTIVE_SUMMARY = `${URL_INSIGHTS_PORTAL}/executive-summary`
const URL_INSIGHTS_PORTAL_ADS_CAMPAIGN = `${URL_INSIGHTS_PORTAL}/campaigns/ads`
const URL_INSIGHTS_PORTAL_CAMPAIGNS_ANALYTICS = `${URL_INSIGHTS_PORTAL}/campaigns-analytics`
const URL_INSIGHTS_PORTAL_CAMPAIGNS_ANALYTICS_OVERVIEW = `${URL_INSIGHTS_PORTAL}/campaigns-analytics/overview`
const URL_INSIGHTS_PORTAL_CAMPAIGNS_ALL_CAMPAIGNS = `${URL_INSIGHTS_PORTAL}/campaigns-analytics/all-campaigns`
const URL_INSIGHTS_PORTAL_CAMPAIGNS_USER_GROWTH = `${URL_INSIGHTS_PORTAL}/campaigns-analytics/user-growth`
const URL_INSIGHTS_PORTAL_CAMPAIGNS_BASKET = `${URL_INSIGHTS_PORTAL}/campaigns-analytics/basket`
const URL_INSIGHTS_PORTAL_CAMPAIGNS_REDEMPTIONS_FUNNEL = `${URL_INSIGHTS_PORTAL}/campaigns-analytics/redemptions-funnel`
const URL_INSIGHTS_PORTAL_CAMPAIGNS_GEOGRAPHY = `${URL_INSIGHTS_PORTAL}/campaigns-geography`
const URL_INSIGHTS_PORTAL_INVENTORY_INTELLIGENCE = `${URL_INSIGHTS_PORTAL}/inventory-intelligence`
const URL_INSIGHTS_PORTAL_COLLECTIONS_INSIGHTS = `${URL_INSIGHTS_PORTAL}/collections-insights`
const URL_INSIGHTS_PORTAL_COLLECTIONS_OVERVIEW = `${URL_INSIGHTS_PORTAL_COLLECTIONS_INSIGHTS}/overview`
const URL_INSIGHTS_PORTAL_COLLECTIONS_ALL_COLLECTIONS = `${URL_INSIGHTS_PORTAL_COLLECTIONS_INSIGHTS}/all-collections`
const URL_INSIGHTS_PORTAL_COLLECTIONS_PERFORMANCE_COMPARISON = `${URL_INSIGHTS_PORTAL_COLLECTIONS_INSIGHTS}/performance-comparison`
const URL_INSIGHTS_PORTAL_COLLECTIONS_PRODUCT_SALES = `${URL_INSIGHTS_PORTAL_COLLECTIONS_INSIGHTS}/product-sales`
const URL_INSIGHTS_PORTAL_PLACEMENTS_INSIGHTS = `${URL_INSIGHTS_PORTAL}/placements-insights`
const URL_INSIGHTS_PORTAL_PLACEMENTS_OVERVIEW = `${URL_INSIGHTS_PORTAL_PLACEMENTS_INSIGHTS}/overview`
const URL_INSIGHTS_PORTAL_PLACEMENTS_ALL_PLACEMENTS = `${URL_INSIGHTS_PORTAL_PLACEMENTS_INSIGHTS}/all-placements`
const URL_INSIGHTS_PORTAL_PLACEMENTS_PERFORMANCE_COMPARISON = `${URL_INSIGHTS_PORTAL_PLACEMENTS_INSIGHTS}/performance-comparison`
// @hygen:inject scoped-urls

// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'insights-portal'>
  | DashRouteType<'insights-portal-redirect-page'>
  | DashRouteType<'insights-portal-performance-dashboard'>
  | DashRouteType<'insights-portal-out-of-stock-dashboard'>
  | DashRouteType<'insights-portal-basket-dashboard'>
  | DashRouteType<'insights-portal-search-dashboard'>
  | DashRouteType<'insights-portal-ads-dashboard'>
  | DashRouteType<'insights-portal-summary-report'>
  | DashRouteType<'insights-portal-summary-report-pdf'>
  | DashRouteType<'insights-portal-data-explorer'>
  | DashRouteType<'insights-portal-report-preview-new'>
  | DashRouteType<'insights-portal-report-preview-existing'>
  | DashRouteType<'insights-portal-custom-report-list'>
  | DashRouteType<'insights-portal-custom-report'>
  | DashRouteType<'insights-portal-performance'>
  | DashRouteType<'insights-portal-performance-overview'>
  | DashRouteType<'insights-portal-performance-basket'>
  | DashRouteType<'insights-portal-performance-out-of-stock'>
  | DashRouteType<'insights-portal-performance-search'>
  | DashRouteType<'insights-portal-executive-summary'>
  | DashRouteType<'insights-portal-ads-campaign'>
  | DashRouteType<'insights-portal-campaigns-analytics'>
  | DashRouteType<'insights-portal-campaigns-analytics-overview'>
  | DashRouteType<'insights-portal-campaigns-analytics-all-campaigns'>
  | DashRouteType<'insights-portal-campaigns-user-growth'>
  | DashRouteType<'insights-portal-campaigns-basket'>
  | DashRouteType<'insights-portal-campaigns-redemptions-funnel'>
  | DashRouteType<'insights-portal-campaigns-geography'>
  | DashRouteType<'insights-portal-inventory-intelligence'>
  | DashRouteType<'insights-portal-collections-insights'>
  | DashRouteType<'insights-portal-collections-insights-overview'>
  | DashRouteType<'insights-portal-collections-insights-all-collections'>
  | DashRouteType<'insights-portal-collections-insights-performance-comparison'>
  | DashRouteType<'insights-portal-collections-insights-product-sales'>
  | DashRouteType<'insights-portal-placements-insights'>
  | DashRouteType<'insights-portal-placements-insights-overview'>
  | DashRouteType<'insights-portal-placements-insights-all-placements'>
  | DashRouteType<'insights-portal-placements-insights-performance-comparison'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'insights-portal': URL_INSIGHTS_PORTAL,
  'insights-portal-redirect-page': URL_INSIGHTS_PORTAL_REDIRECT_PAGE,
  'insights-portal-performance-dashboard': URL_INSIGHTS_PORTAL_PERFORMANCE_DASHBOARD,
  'insights-portal-out-of-stock-dashboard': URL_INSIGHTS_PORTAL_OUT_OF_STOCK_DASHBOARD,
  'insights-portal-basket-dashboard': URL_INSIGHTS_PORTAL_BASKET_DASHBOARD,
  'insights-portal-search-dashboard': URL_INSIGHTS_PORTAL_SEARCH_DASHBOARD,
  'insights-portal-ads-dashboard': URL_INSIGHTS_PORTAL_ADS_DASHBOARD,
  'insights-portal-summary-report': URL_INSIGHTS_PORTAL_SUMMARY_REPORT,
  'insights-portal-summary-report-pdf': URL_INSIGHTS_PORTAL_SUMMARY_REPORT_PDF,
  'insights-portal-data-explorer': URL_INSIGHTS_PORTAL_DATA_EXPLORER,
  'insights-portal-report-preview-new': URL_INSIGHTS_PORTAL_REPORT_PREVIEW_NEW,
  'insights-portal-report-preview-existing': URL_INSIGHTS_PORTAL_REPORT_PREVIEW_EXISTING,
  'insights-portal-custom-report-list': URL_INSIGHTS_PORTAL_CUSTOM_REPORT_LIST,
  'insights-portal-custom-report': URL_INSIGHTS_PORTAL_CUSTOM_REPORT,
  'insights-portal-performance': URL_INSIGHTS_PORTAL_PERFORMANCE,
  'insights-portal-performance-overview': URL_INSIGHTS_PORTAL_PERFORMANCE_OVERVIEW,
  'insights-portal-performance-basket': URL_INSIGHTS_PORTAL_PERFORMANCE_BASKET,
  'insights-portal-performance-out-of-stock': URL_INSIGHTS_PORTAL_PERFORMANCE_OUT_OF_STOCK,
  'insights-portal-performance-search': URL_INSIGHTS_PORTAL_PERFORMANCE_SEARCH,
  'insights-portal-executive-summary': URL_INSIGHTS_PORTAL_EXECUTIVE_SUMMARY,
  'insights-portal-ads-campaign': URL_INSIGHTS_PORTAL_ADS_CAMPAIGN,
  'insights-portal-campaigns-analytics': URL_INSIGHTS_PORTAL_CAMPAIGNS_ANALYTICS,
  'insights-portal-campaigns-analytics-overview': URL_INSIGHTS_PORTAL_CAMPAIGNS_ANALYTICS_OVERVIEW,
  'insights-portal-campaigns-analytics-all-campaigns': URL_INSIGHTS_PORTAL_CAMPAIGNS_ALL_CAMPAIGNS,
  'insights-portal-campaigns-user-growth': URL_INSIGHTS_PORTAL_CAMPAIGNS_USER_GROWTH,
  'insights-portal-campaigns-basket': URL_INSIGHTS_PORTAL_CAMPAIGNS_BASKET,
  'insights-portal-campaigns-redemptions-funnel': URL_INSIGHTS_PORTAL_CAMPAIGNS_REDEMPTIONS_FUNNEL,
  'insights-portal-campaigns-geography': URL_INSIGHTS_PORTAL_CAMPAIGNS_GEOGRAPHY,
  'insights-portal-inventory-intelligence': URL_INSIGHTS_PORTAL_INVENTORY_INTELLIGENCE,
  'insights-portal-collections-insights': URL_INSIGHTS_PORTAL_COLLECTIONS_INSIGHTS,
  'insights-portal-collections-insights-overview': URL_INSIGHTS_PORTAL_COLLECTIONS_OVERVIEW,
  'insights-portal-collections-insights-all-collections':
    URL_INSIGHTS_PORTAL_COLLECTIONS_ALL_COLLECTIONS,
  'insights-portal-collections-insights-performance-comparison':
    URL_INSIGHTS_PORTAL_COLLECTIONS_PERFORMANCE_COMPARISON,
  'insights-portal-collections-insights-product-sales':
    URL_INSIGHTS_PORTAL_COLLECTIONS_PRODUCT_SALES,
  'insights-portal-placements-insights': URL_INSIGHTS_PORTAL_PLACEMENTS_INSIGHTS,
  'insights-portal-placements-insights-overview': URL_INSIGHTS_PORTAL_PLACEMENTS_OVERVIEW,
  'insights-portal-placements-insights-all-placements':
    URL_INSIGHTS_PORTAL_PLACEMENTS_ALL_PLACEMENTS,
  'insights-portal-placements-insights-performance-comparison':
    URL_INSIGHTS_PORTAL_PLACEMENTS_PERFORMANCE_COMPARISON,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
